import { SvgIcon, SvgIconTypeMap } from '@mui/material'
import { DefaultComponentProps } from '@mui/material/OverridableComponent'
import React from 'react'
import './css/eco-spinner.scss'

/**
 * 
 * Icon of EcoMundo
 * 
 * ###Import to use it
 *
 *`import { EcoSpinner } from '@eco/react-lib'`
 *
 *### Usage
 *
 *`<EcoSpinner />`
 *
 *### Basic Example
 */

export const EcoSpinner = ({ message, ...props }: EcoSpinnerType) => {
    
    return (
        <React.Fragment>
            <SvgIcon className={`dots-loader ${props.className}` } {...props}>
                <g>
                    <path d="M21.7,7.8c0,0.2-0.1,0.4-0.1,0.6c0,0.2,0,0.5,0,0.7c0,0.4,0,0.7-0.1,1c-0.2,1.2-0.5,2.3-0.7,3.5c0,0.1,0,0.2,0,0.3
                        c-0.1,0.2-0.1,0.4-0.2,0.6c-0.3,0.5-0.5,1.1-0.5,1.7c0,0.1,0,0.3-0.1,0.4c-0.4,1-0.9,1.9-1.3,2.9c-0.7,1.5-1.8,2.6-3.3,3.3
                        c-0.5,0.2-1.1,0.5-1.6,0.7c-0.5,0.2-1,0.3-1.5,0.4c-0.3,0-0.7-0.1-1-0.1c-0.6-0.1-1.1-0.1-1.6-0.2c-0.2,0-0.4-0.1-0.5-0.4
                        c-0.1-0.2-0.3-0.2-0.4-0.2c-0.3,0-0.6,0-0.9,0C7,23,6.3,22.6,5.6,22.2c-0.4-0.3-0.9-0.5-1.3-0.8C4.2,21.3,4,21.2,3.9,21
                        c-0.3-0.6-0.6-1.1-0.8-1.7C3,19,3,18.6,2.9,18.2c-0.1-0.4-0.1-0.7-0.2-1.1c-0.3-0.9-0.5-1.8-0.4-2.7c0.1-1.2,0.1-2.3,0.3-3.5
                        c0.1-0.6,0.4-1.2,0.6-1.8c0.2-0.8,0.5-1.5,0.7-2.3c0-0.1,0-0.2,0.1-0.2c0.4-0.5,0.6-1.1,0.7-1.7c0.1-0.6,0.5-1,1-1.4
                        c0.1-0.1,0.2-0.2,0.2-0.3c0.3-0.8,1-1.3,1.7-1.7c0.4-0.2,0.7-0.4,1-0.7c0.2-0.2,0.5-0.3,0.8-0.5c0.2-0.1,0.3-0.1,0.5-0.2
                        c0.5-0.3,1-0.3,1.6,0c0.1,0,0.3,0,0.4,0c0.1,0,0.2-0.1,0.2-0.1c0.5,0,1,0,1.5,0c0.2,0,0.5,0.1,0.7,0.1c0.6,0.2,1.3,0.3,1.9,0.5
                        c0.6,0.2,1.2,0.4,1.7,0.9c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.2,0.4,0.5,0.6,0.8c1.1,1,1.9,2.3,2.2,3.8
                        C21.6,7,21.7,7.4,21.7,7.8C21.8,7.8,21.8,7.8,21.7,7.8z M6.5,4.9C6.5,4.9,6.5,4.9,6.5,4.9C6.3,5.1,6.1,5.3,5.9,5.5
                        C5.6,5.8,5.3,6.1,5.1,6.6C5,7,4.8,7.4,4.5,7.8C4.4,7.9,4.4,8,4.4,8c0.1,0.4-0.1,0.6-0.3,0.9c-0.7,1.2-1.1,2.5-1,4
                        c0,0.5,0.2,1,0.4,1.5c0.1,0.3,0.1,0.5,0,0.8c-0.4,0.6-0.2,1.2,0,1.8c0.1,0.4,0.3,0.7,0.4,1c0.1,0.2,0.1,0.3,0.2,0.5
                        c0.1,0.2,0.2,0.4,0.3,0.6c0.5,0.5,0.8,1,1.1,1.6C5.7,21,6,21.3,6.4,21.5c0.7,0.3,1.4,0.6,2.1,0.8c0.6,0.2,1.2,0.3,1.8,0.6
                        c0.1,0.1,0.3,0,0.5,0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7,0,1.1,0c0.7,0.1,1.2-0.4,1.7-0.8c0,0,0,0,0,0
                        c0.2-0.5,0.7-0.7,1.1-0.9c0.3-0.2,0.6-0.3,0.9-0.6c0.8-0.7,1.4-1.5,1.9-2.3c0.4-0.7,0.8-1.4,0.7-2.3c0-0.1,0.1-0.2,0.1-0.3
                        c0.2-0.5,0.4-0.9,0.6-1.4c0-0.1,0.1-0.3,0-0.4c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.6,0-1.2,0.5-1.5c0.3-0.2,0.5-0.5,0.6-0.8
                        c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.5,0-1-0.1-1.5c-0.2-1.1-0.8-2-1.5-2.8c-0.1-0.2-0.3-0.3-0.4-0.4c-0.1-0.4-0.4-0.6-0.7-0.9
                        c-0.3-0.2-0.5-0.5-0.8-0.7C17,2.9,17,2.8,16.9,2.7c-0.3-0.4-0.6-0.6-1-0.8c-0.6-0.2-1.3-0.4-1.9-0.6c0,0-0.1,0-0.1,0
                        c-0.4,0.1-0.7,0.1-1.1,0.1c-0.1,0-0.2,0-0.2,0C12,1,11.3,1,10.6,1c-0.4,0-0.8,0.2-1.2,0.4c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0.1,0.1
                        C9.1,1.9,8.8,2.1,8.5,2C8.2,1.9,8.1,2,8,2.2C7.7,2.7,7.3,3.1,6.9,3.4C6.6,3.6,6.5,3.9,6.5,4.2c0,0.1,0,0.3,0,0.4
                        C6.5,4.7,6.5,4.8,6.5,4.9z"/>
                    <path d="M14.3,11.9c-0.2,0.3-0.3,0.5,0,0.8c0.3,0.3,0.6,0.6,0.9,0.9c0.6,0.5,1.1,1,1.2,1.8c0.1,0.9,0,1.8-0.7,2.5
                        c-0.3,0.4-0.6,0.7-0.9,1.1c-0.1,0.1-0.1,0.2-0.2,0.2c-0.9,0.5-1.9,0.8-3,0.4c-0.3-0.1-0.5-0.3-0.7-0.5c-0.6-0.7-1.1-1.4-1.6-2.1
                        c-0.1-0.2-0.2-0.2-0.4-0.2c-0.5,0-0.9,0-1.4-0.1c-1.6-0.3-2.3-1.8-1.5-3.2c0.3-0.5,0.7-1.1,1.3-1.2c0.7-0.2,1.2-0.5,1.7-1
                        c0.2-0.1,0.3-0.3,0.4-0.5c0.4-0.5,1.4-0.7,1.9-0.3c0.4,0.4,0.9,0.5,1.4,0.5c0.4,0,0.7,0.2,0.9,0.4C13.9,11.6,14.1,11.8,14.3,11.9z
                        "/>
                </g>
                <path className="animate-key one" d="M4.4,11c0-0.5,0.1-1,0.5-1.5C5.3,9,6,9,6.5,9.6c0.5,0.7,0.5,1.4,0.2,2.1c-0.2,0.5-0.7,0.7-1.3,0.5
                    C4.6,12.1,4.4,11.7,4.4,11z"/>
                <path className="animate-key two" d="M6.9,7.5c0-0.1,0-0.1,0-0.2C6.9,7.2,7,7.1,7,7C7,6.5,7.2,6.1,7.5,5.7C8.2,5,9,5.2,9.3,6.1c0.3,0.8,0.2,1.7-0.2,2.5
                    C9,8.8,8.8,8.9,8.6,9C7.8,9.2,7.1,8.6,7,7.8C7,7.7,6.9,7.6,6.9,7.5z"/>
                <path className="animate-key three" d="M11.4,3.7c0.1,0,0.1,0,0.2,0c0.5,0.2,0.8,0.6,0.9,1.1c0.2,0.9,0,1.8-0.3,2.7c-0.1,0.2-0.3,0.4-0.6,0.5
                    c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.6-0.2-0.9-0.6-1.1-1.2C10,6.6,10,6.5,10,6.4c0-0.1,0-0.2,0-0.4C10,5.9,10,5.8,10,5.8
                    C10.2,4.8,10.5,4,11.4,3.7z"/>
                <path className="animate-key four" d="M14.5,9.1c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c-0.5-0.1-0.8-0.5-0.9-1c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.1,0-0.2
                    c0-0.1,0.1-0.1,0.1-0.2c0.1-0.6,0.2-1.2,0.5-1.7C13.8,5.2,14,5,14.2,4.9c0.3-0.3,0.7-0.3,1,0.1c0.2,0.2,0.3,0.4,0.4,0.7
                    c0.2,0.8,0.2,1.6,0,2.4c-0.1,0.4-0.3,0.8-0.8,1C14.7,9,14.6,9,14.5,9.1z"/>
                <path className="animate-key five" d="M17.5,13.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.8-0.1-1.3-0.6-1.5-1.3c-0.2-0.8-0.2-1.5,0.1-2.3
                    c0.2-0.7,0.9-1.2,1.5-1.2c0.6,0,1.1,0.5,1.4,1.2c0.2,0.5,0.2,1.1,0.1,1.6C18.6,12,18.5,12.9,17.5,13.2z"/>
            </SvgIcon>
            {
                message && <div className="loading-message">{message}</div>
            }
        </React.Fragment>
    )
}

export type EcoSpinnerType = DefaultComponentProps<SvgIconTypeMap<{}, "svg">> & {
    /** Message to show under loading spinner */
    message?: string
}
